module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-4-0fc3f7bfcd928fca73743848ad053ad4.webp";